import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    gap: theme.spacing.space16,
    display: "flex",
    flexDirection: "column",
  },
  headerTitle: {
    margin: `0 ${theme.spacing.space16}px`,
  },
  content: {
    padding: `0 ${theme.spacing.space20}px`,
    display: "grid",
    gridGap: theme.spacing.space16,
    gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
  },
  gems: {
    position: "absolute",
    bottom: 0,
    right: 0,
    background: "rgba(0, 0, 0, 0.45)",
    width: 44,
    height: 44,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: `${theme.radius.small}px 0px`,
  },
  gemImg: {
    height: 25,
    width: 29,
    zIndex: 2,
  },
}));
